import React from 'react';
import { Icons } from '@ublend-npm/aulaui-core';
import ManageWidget from './widgets/manageWidget';
import MessagesWidget from './widgets/messagesWidget';
import StarredSpacesWidget from './widgets/starredSpacesWidget';
import RecentlyViewedSpacesWidget from './widgets/recentlyViewedSpacesWidget/RecentlyViewedSpacesWidget';
import RecentUpdates from './widgets/RecentUpdates';
import UpcomingAssignmentsWidget from './widgets/upcomingAssignmentsWidget';
import { WidgetLayoutProfile } from './layout/widgetLayout.types';

export const HOME_SPACES_WIDGET_IDS = [
  'home-switchrole-widget',
  'home-greeting-widget',
  'home-space-widget',
] as const;

export type HomeWidgetDefinition = {
  id: string;
  component: React.ReactNode;
  icon: React.ReactNode;
  title: string;
  ariaLabel?: string;
  layout: WidgetLayoutProfile;
  /** @deprecated Use layout.colSpan — kept for backward compatibility during migration */
  size?: Record<string, number>;
};

const widgetsLibrary: HomeWidgetDefinition[] = [
  {
    id: 'home-switchrole-widget',
    component: null,
    icon: <Icons.AssignmentOutlined />,
    title: 'Switch Role',
    layout: {
      zone: 'hero',
      visibility: 'fixed',
      sizeProfile: 'card',
      colSpan: { xs: 12 },
      order: 0,
    },
    size: { lg: 12, md: 12, xs: 12 },
  },
  {
    id: 'home-greeting-widget',
    component: null,
    icon: <Icons.AssignmentOutlined />,
    title: 'Greeting',
    ariaLabel: 'Greeting Widgets',
    layout: {
      zone: 'hero',
      visibility: 'fixed',
      sizeProfile: 'card',
      colSpan: { xl: 2, lg: 2, xs: 12 },
      order: 1,
    },
    size: { lg: 2, md: 12, xs: 12 },
  },
  {
    id: 'home-space-widget',
    component: null,
    icon: <Icons.AssignmentOutlined />,
    title: 'Space',
    ariaLabel: 'Space Widget',
    layout: {
      zone: 'hero',
      visibility: 'fixed',
      sizeProfile: 'wide',
      colSpan: { xl: 7, lg: 6, xs: 12 },
      order: 2,
    },
    size: { lg: 10, md: 12, xs: 12 },
  },
  {
    id: 'home-messages-widget',
    component: <MessagesWidget />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Messages Widgets',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 10,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-upcoming-assignments-widget',
    component: <UpcomingAssignmentsWidget />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Upcoming assignments',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 20,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-recently-viewed-spaces-widget',
    component: <RecentlyViewedSpacesWidget />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Recently viewed spaces',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 30,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-starred-spaces-widget',
    component: <StarredSpacesWidget />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Starred spaces',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 40,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-manage-widget',
    component: <ManageWidget />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Manage Widgets',
    layout: {
      zone: 'main',
      visibility: 'fixed',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 100,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-recent-updates-widget',
    component: <RecentUpdates />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Recent Updates',
    layout: {
      zone: 'sidebar',
      visibility: 'fixed',
      sizeProfile: 'long',
      colSpan: { xl: 3, lg: 4, md: 5, xs: 12 },
      order: 5,
    },
    size: { xl: 3, lg: 4, md: 5, sm: 12, xs: 12 },
  },
];

export default widgetsLibrary;
